<template>
	<div
		class="lg:px-4"
		id="popular-post-section"
	>
		<div
			class="flex flex-col sm:flex-row justify-center sm:justify-between items-center mb-[32px] lg:my-[64px] text-center sm:text-left"
		>
			<h2
				class="text-[32px] text-white lg:text-6xl font-medium text-white leading-10"
			>
				Popular Posts
			</h2>
			<LinkWithArrow
				text-color="text-white"
				label="All Blogs & Insights"
				class="hidden sm:flex"
				link="/blog"
			/>
		</div>
		<div
			class="flex flex-col md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[24px]"
		>
			<popular-post-card
				v-if="posts && posts.length > 0"
				v-for="(post, index) in posts"
				:key="index"
				:title="post.title"
				:image="post.image"
				:description="post.description"
				:comments_count="post.comments_count"
				:link="post.link"
				style="flex: 1; flex-grow: 1"
			/>
		</div>

		<div class="sm:hidden flex justify-center items-center mt-4">
			<LinkWithArrow
				text-color="text-white"
				label="All Blogs & Insights"
			/>
		</div>
	</div>
</template>

<script setup>
const { data: posts } = await useAsyncData("popular-posts", async () => {
	try {
		const { posts: postsData, screenerPage } = await $fetch(
			"/api/featured-posts"
		);
		const result = [];

		if (postsData) {
			postsData.forEach((post) => {
				result.push({
					title: post.title?.rendered ?? post.title,
					image: post.featured_media?.source_url ?? post.featuredImage?.node?.sourceUrl ?? null,
					link: post.slug ? `/${post.slug}/` : post.uri,
					description: post.content?.rendered ?? post.excerpt,
					comments_count: post.comments_count ?? post.commentCount ?? 0
				});
			});
		}

		if (screenerPage) {
			result.push({
				title: screenerPage.title?.rendered ?? screenerPage.title,
				image: screenerPage.featured_media?.source_url ?? screenerPage.featuredImage?.node?.sourceUrl ?? null,
				link: screenerPage.slug ? `/${screenerPage.slug}/` : screenerPage.uri,
				description: screenerPage.content?.rendered ?? screenerPage.content,
				comments_count: 0
			});
		}

		return result;
	} catch (error) {
		console.error(error);
	}
}).catch((error) => {
	if (error.cause.statusCode === 404) {
		throw createError({
			statusCode: 404,
			fatal: true
		});
	} else {
		throw createError({
			statusCode: 500,
			statusMessage: error,
			fatal: true
		});
	}
});
</script>
